import { useRequirementFieldPath } from './useRequirementFieldPath';

export const useRequirementCombinatorFieldPath = () => {
  const requirement = useRequirementFieldPath();
  return `${requirement}.combinator` as const;
};
